"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SwitchBox_1 = __importDefault(require("@components/SwitchBox"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
function TemplateItemDraggable(_a) {
    var section = _a.section, index = _a.index, value = _a.value, onValueChanged = _a.onValueChanged;
    var disabled = section.disabled, label = section.label, id = section.id;
    var _b = __read((0, react_1.useState)(false), 2), hovered = _b[0], setHovered = _b[1];
    (0, react_1.useEffect)(function () {
        if (!disabled) {
            setHovered(false);
        }
    }, [disabled]);
    return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { key: id, draggableId: id, index: index }, function (provided, snapshot) { return (react_1.default.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { onMouseEnter: function () { return !disabled && setHovered(true); }, onMouseLeave: function () { return !disabled && setHovered(false); }, className: (0, clsx_1.default)('template-item-draggable', snapshot.isDragging && 'template-item-draggable--hovered', !disabled && hovered && 'template-item-draggable--hovered', !value && 'template-item-draggable--switch-off'), style: provided.draggableProps.style }),
        react_1.default.createElement("div", { className: "template-item-draggable__left" },
            react_1.default.createElement("div", { className: "template-item-draggable__icon implioicons-draggable" }),
            react_1.default.createElement("div", { className: "template-item-draggable__text" }, label)),
        react_1.default.createElement(SwitchBox_1.default, { checked: value, onToggle: function () { return onValueChanged(!value); } }))); }));
}
exports.default = TemplateItemDraggable;
